import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useCallback, useEffect } from "react";
import { getCategoriesAction } from "../../../../store/actions/categories";

export default function CategoriesSelect({
  title,
  onChange,
  value,
  error,
  helperText,
  placeHolder,
  disableBorder,
  removePadding,
}) {
  const dispatch = useDispatch();

  const categories = useSelector((s) => s?.categories?.data);
  const hasMore = useSelector((s) => s?.categories?.hasMore);
  const loading = useSelector((s) => s?.categories?.loading);

  const getCategories = useCallback(
    ({ next = false }) => {
      getCategoriesAction({ next, limit: 12 })(dispatch);
    },
    [dispatch]
  );

  const onScrolled = (e) => {
    if (loading) return;
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    if (scrollTop + clientHeight + 50 >= scrollHeight && hasMore) {
      getCategories({ next: true });
    }
  };

  useEffect(() => {
    getCategories && getCategories({});
  }, [getCategories]);

  return (
    <Autocomplete
      multiple
      fullWidth
      sx={{
        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
          disableBorder && {
            border: 0,
          },
        "& .MuiOutlinedInput-root": removePadding && {
          paddingTop: "0px!important",
          paddingBottom: "0px!important",
          paddingLeft: "0px!important",
        },
      }}
      value={value ? value : ""}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option?.name || ""}
      options={categories}
      loading={loading}
      onChange={onChange}
      componentsProps={{
        paper: { onScroll: onScrolled, sx: { maxHeight: "300px" } },
      }}
      renderInput={(params) => (
        <TextField
          error={error}
          helperText={helperText}
          {...params}
          label={title}
          placeholder={placeHolder}
          InputProps={{
            ...params.InputProps,
            error,
            helperText,
            endAdornment: (
              <Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
          }}
        />
      )}
    />
  );
}
